import React, { useContext, useEffect, useState } from 'react'
import SearchTable from 'src/components/searchTable'
import { checkPermissions } from 'src/views/utils/helper'
import { CFormSwitch } from '@coreui/react'
import CIcon from '@coreui/icons-react'
import { cilPencil } from '@coreui/icons'
import moment from 'moment'
import { GlobalContext } from '../../context/GlobalState'
import { PERMISSIONS } from '../../utils/permissions'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faAngleDoubleDown } from '@fortawesome/free-solid-svg-icons'
import useAxios from 'axios-hooks'
import { CONTENT_RATING_API } from '../../utils/urls'
import { raiseToast } from '../../utils/helper'
import { AppContext } from '../../context/app'
import ContentRatingModal from './contentRatingModal'

const ContentRating = () => {
  const { setLoader, accountObj } = useContext(AppContext)
  const [selectedRating, setSelectedRating] = useState({})
  const language = localStorage.getItem('language')
  const [openModal, setOpenModal] = useState(false)

  const { userSessionObj } = useContext(GlobalContext)
  const defaultLangCheck = language === accountObj?.default_language
  const isCreateAllowed =
    checkPermissions(userSessionObj.session_data.permissions, PERMISSIONS.CONTENT.CREATE) &&
    defaultLangCheck

  const isUpdateAllowed = checkPermissions(
    userSessionObj.session_data.permissions,
    PERMISSIONS.CONTENT.UPDATE,
  )

  const [{ data: ratingList, loading: ratingLoading }, ratingCall] = useAxios(
    {
      url: CONTENT_RATING_API,
      method: 'get',
    },
    { manual: true },
  )

  const [{ data: createRating, loading: createRatingLoading }, ratingCreateCall] = useAxios(
    {
      url: CONTENT_RATING_API,
      method: 'post',
    },
    { manual: true },
  )

  const [{ data: updateRating, loading: updateRatingLoading }, ratingUpdateCall] = useAxios(
    {
      url: CONTENT_RATING_API,
      method: 'put',
    },
    { manual: true },
  )

  useEffect(() => {
    ratingCall()
  }, [])

  useEffect(() => {
    setLoader(ratingLoading || createRatingLoading || updateRatingLoading)
  }, [ratingLoading, createRatingLoading, updateRatingLoading])

  useEffect(() => {
    if (createRating && createRating.success) {
      ratingCall()
      raiseToast('success', 'Content Rating created successfully')
    }
  }, [createRating])

  useEffect(() => {
    if (updateRating && updateRating.success) {
      ratingCall()
      raiseToast('success', 'Content Rating updated successfully')
    }
  }, [updateRating])

  const handleStatus = (info) => {
    if (!isUpdateAllowed) {
      raiseToast('error', "You don't have enough permission")
      return
    }
    editRating({ status: !info.status }, info._id)
  }

  const addRating = (payload) => {
    ratingCreateCall({
      data: payload,
    })
    setOpenModal(false)
  }

  const editRating = (payload, id) => {
    ratingUpdateCall({
      params: {
        content_rating_id: id,
      },
      data: payload,
    })
    setOpenModal(false)
  }

  const handleEdit = (info) => {
    if (!isUpdateAllowed) {
      raiseToast('error', "You don't have enough permission")
      return
    }
    setSelectedRating(info)
    setOpenModal(true)
  }

  const handleAdd = () => {
    if (!isCreateAllowed) {
      raiseToast('error', "You don't have enough permission")
      return
    }
    setSelectedRating({})
    setOpenModal(!openModal)
  }

  const tableConfig = [
    {
      header: 'Name',
      dataCell: (info) => info.name,
      width: 22,
    },
    {
      header: 'Description',
      dataCell: (info) => info.description,
      width: 33,
    },
    {
      header: 'Created On',
      dataCell: (info) => moment.utc(info.created_date).format('DD-MM-YYYY'),
      width: 15,
    },
    {
      header: 'Status',
      dataCell: (info) => (
        <CFormSwitch
          label={info.status ? 'Active' : 'Disabled'}
          checked={info.status}
          valid={info.status}
          value={info.status}
          onChange={() => handleStatus(info)}
          size="lg"
        />
      ),
      width: 18,
    },

    {
      header: <FontAwesomeIcon icon={faAngleDoubleDown} size="lg" className="mx-1" />,
      dataCell: (info) => (
        <CIcon
          icon={cilPencil}
          style={{ cursor: 'pointer' }}
          size="lg"
          title="Edit"
          onClick={() => handleEdit(info)}
        />
      ),
      width: 7,
    },
  ]
  return (
    <>
      <h4>Censorship Rating</h4>
      <p>{`Maturity Rating of your Content`}</p>
      <SearchTable
        type={`Content Rating`}
        tableCardHeight={65}
        disableButton={false}
        buttonName={`+ Add`}
        buttonFunction={handleAdd}
        searchTerm={`name`}
        tableContent={ratingList && ratingList.data}
        tableConfig={tableConfig}
        createPermission={isCreateAllowed}
        disabledButtonTitle={
          defaultLangCheck ? '' : 'Adding Content Rating Available on Default Language'
        }
      />

      {openModal && (
        <ContentRatingModal
          data={selectedRating}
          openModal={openModal}
          onCancel={() => {
            setOpenModal(false)
            setSelectedRating({})
          }}
          addCallback={addRating}
          updateCallback={editRating}
        />
      )}
    </>
  )
}

export default ContentRating
